import { render, staticRenderFns } from "./ModalEditCommissary.vue?vue&type=template&id=2a1e1d26&"
import script from "./ModalEditCommissary.vue?vue&type=script&lang=ts&"
export * from "./ModalEditCommissary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports